import { trimEnd, setWith, isArray, merge } from 'lodash';

const symbols = {
  api: Symbol('API instance property'),
  endpoint: Symbol('Config API endpoint property'),
};

function addSetting(data, domain, resource, name, value) {
  setWith(data, [domain, resource, name], value, Object);

  return data;
}

function addResource(data, domain, { id, settings }) {
  return settings.reduce((out, setting) => (
    addSetting(out, domain, id, setting.key, setting.value)
  ), data);
}

function addDomain(data, { id, resources }) {
  return resources.reduce((out, resource) => (
    addResource(out, id, resource)
  ), data);
}

const loadResource = async (baseUrl, path, request = fetch) => {
  const [domain, resource, setting] = path.split('.');

  if (!domain) {
    throw new Error('Invalid configuration path');
  }

  const url = [
    trimEnd(baseUrl, '/'),
    ...['domains', domain],
    ...(resource ? ['resources', resource] : []),
    ...(setting ? ['settings', setting] : []),
  ].join('/');

  let data = {};
  try {
    data = await request(url);
  } catch (e) {
    return {};
  }

  const out = {};

  if (setting) {
    addSetting(out, domain, resource, setting, data);
  } else if (resource) {
    addResource(out, domain, data);
  } else {
    addDomain(out, data);
  }

  return out;
};

export default class Loader {
  constructor(api, endpoint) {
    this[symbols.api] = api;
    this[symbols.endpoint] = endpoint;
  }

  async load(resources) {
    const toLoad = isArray(resources) ? resources : [resources];
    const endpoint = this[symbols.endpoint];
    const request = ::this[symbols.api].request;

    const promises = toLoad.map(path => loadResource(endpoint, path, request));
    const dataList = await Promise.all(promises);

    return merge({}, ...dataList);
  }
}



// WEBPACK FOOTER //
// ./src/Configs/Loader.js